import TriggerProvider from './TriggerProvider';
import { TriggerContent, TriggerKnob, TriggerState } from './components';

let TRIGGER_ID = 0;

export const chartCreateTrigger = () => {
  const id = ++TRIGGER_ID + '';

  return {
    State: (props) => <TriggerState {...props} id={id} />,
    Knob: (props) => <TriggerKnob {...props} id={id} />,
    Content: (props) => <TriggerContent {...props} id={id} />,
  };
};

export { TriggerProvider };
